import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import React from 'react';

function Footer() {
    return (
        <AppBar position="static" sx={{ backgroundColor: '#90caf9' }} elevation={2}>
            <Toolbar sx={{justifyContent: 'center', spacing: 2}}>
                <Box component="img"
                     src="/images/logoIRIC.png"
                     alt="IRIC Logo"
                     sx={{height: 100}}
                />
                <Box component="img"
                     src="/images/logoUDEM.png"
                     alt="DIRO Logo"
                     sx={{height: 120, pr: 2}}
                />
                <Box component="img"
                     src="/images/logoDIRO.png"
                     alt="DIRO Logo"
                     sx={{height: 24, pr: 10}}
                />
            </Toolbar>
        </AppBar>
    );
}

export default Footer;
